import { toast } from 'react-toastify';
import { ToastMessage } from './ToastMessage';

export const toastError = (message: string) => {
    toast.error(
        <ToastMessage message={message} />,
        {
            className: 'p-0',
            toastId: message,
        },
    );
};

export const toastInfo = (message: string) => {
    toast.info(
        <ToastMessage message={message} />,
        {
            className: 'p-0',
            toastId: message,
        },
    );
};